import * as React from 'react';
import { Form, Text, Select, Checkbox, TextArea } from 'react-form';
import { SingleDatePicker } from 'react-dates';
import { api } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { Switch } from '@src/services/form';
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

// typing
interface LocalProps extends PropsEdit {
}
interface LocalState extends StateEdit {
    focused: any;
    departments: any;
}

// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Customer extends ProtoEdit<LocalProps, LocalState> {
    state = {
        departments: []
    } as LocalState;

    addDepartment( formApi ) {
        const val = formApi.getFormState().values.newDept;
        const departments = [...this.state.departments, { description: val }];
        this.setState({
            departments
        });
        formApi.setValue('newDept', '');
    }

    removeDepartment( i ) {
        let departments = this.state.departments;
        departments.splice(i, 1);
        this.setState({
            departments
        });
    }

    localSave( v ) {
        v = { ...v, departments: this.state.departments };
        this.save(v);
    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return null;
        const { id, onCancel } = this.props;
        const { departments, data, values = {}, entity = null, error } = this.state;
        if (entity === null) return null;
        
        const countries = data.countries.map( v => ({ value: v.id, label: v.name }));

        return (
            <Modal
                title={!id ? _('new_title', 'SettingsCustomer') : _('edit_title', 'SettingsCustomer', { name: entity.description } ) }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.localSave(v)}
                        defaultValues={entity}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="customer">{_('field_customer', 'SettingsCustomer')}</label>
                                    <Text field="customer" id="customer" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="description">{_('field_description', 'SettingsCustomer')}</label>
                                    <Text field="description" id="description" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="email">{_('field_email', 'SettingsCustomer')}</label>
                                    <Text field="email" id="email" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="address">{_('field_address', 'SettingsCustomer')}</label>
                                    <TextArea field="address" id="address" className="form-control" />
                                </article>
                                <article className="pt">
                                    <label htmlFor="zipcode">{_('field_zipcode', 'SettingsCustomer')}</label>
                                    <Text field="zipcode" id="zipcode" className="form-control" />
                                </article>
                                <article className="pt">
                                    <label htmlFor="city">{_('field_city', 'SettingsCustomer')}</label>
                                    <Text field="city" id="city" className="form-control" />
                                </article>
                                <article className="pt">
                                    <label htmlFor="county">{_('field_county', 'SettingsCustomer')}</label>
                                    <Text field="county" id="county" className="form-control" />
                                </article>
                                <article className="pt">
                                    <label htmlFor="country_id">{_('field_country_id', 'SettingsCustomer')}</label>
                                    <Select field="country_id" id="country_id" options={countries} className="form-control" />
                                </article>
                                <article className="switch">
                                    <label htmlFor="active">{_('field_active', 'SettingsCustomer')}</label>
                                    <Switch field="active" id="active" />
                                </article>
                            </div>
                            {!id &&
                            <div className="departments">
                                <hr />
                                <h4>{_(`title_newDept`, 'SettingsCustomer')}</h4>
                                <table className="table"><tbody>
                                {departments && departments.map( (d, i) => (
                                <tr key={i}>
                                    <td>{d.description}</td>
                                    <td className="text-right"><button type="button" className="btn btn-cancel btn-danger" onClick={() => this.removeDepartment(i)}><i className="fa fa-remove" /> {_(`delete_newDept`, 'SettingsCustomer')}</button></td>
                                </tr>
                                ))}
                                <tr>
                                    <td><Text field="newDept" id="newDept" placeholder={_('field_newDept', 'SettingsCustomer')} onKeyDown={(e) => { if(e.keyCode == 13) { e.preventDefault(); this.addDepartment(formApi) }; }} className="form-control" /></td>
                                    <td className="text-right"><button type="button" className="btn btn-success" onClick={() => { this.addDepartment(formApi) } }>{_(`btn_newDept`, 'SettingsCustomer')}</button></td>
                                </tr>
                                </tbody></table>
                            </div>
                            }
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary">
                                {_(`btn_save`, 'Settings')} 
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Customer.tsx